import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from '@seafile/slate-react';
import withInline from './controller/inline-element-controller';
import withBlock from './controller/block-element-controller';
import withVoid from './controller/void-element-controller';
import withMarkdownShortcut from './controller/shortcut-controller';
import normalizeNode from './controller/normalize-controller';
import { EditorUtils } from './editor-utils/common-editor-utils';
import TableUtils from './editor-utils/block-element-utils/table-utils';
var EditorContext = /*#__PURE__*/function () {
  function EditorContext() {
    _classCallCheck(this, EditorContext);
    this.editor = null;
    this.tableUtils = null;
    this.editorUtils = null;
  }
  _createClass(EditorContext, null, [{
    key: "getEditor",
    value: function getEditor(options) {
      if (this.editor && options) {
        if (options && options.onSave) {
          this.editor.onSave = options.onSave;
        }
        if (options && options.editorApi) {
          this.editor.editorApi = options.editorApi;
        }
        if (options && options.columns) {
          this.editor.columns = options.columns;
        }
      }
      if (this.editor) return this.editor;
      this.editor = normalizeNode(withMarkdownShortcut(withVoid(withBlock(withInline(withHistory(withReact(createEditor())))))));
      if (options && options.onSave) {
        this.editor.onSave = options.onSave;
      }
      if (options && options.editorApi) {
        this.editor.editorApi = options.editorApi;
      }
      if (options && options.columns) {
        this.editor.columns = options.columns;
      }
      return this.editor;
    }
  }, {
    key: "resetEditor",
    value: function resetEditor() {
      this.editor = null;
      this.editorUtils = null;
      this.tableUtils = null;
    }
  }, {
    key: "getEditorRef",
    value: function getEditorRef() {
      var editorRef = window.abcdef_editor;
      return editorRef;
    }
  }, {
    key: "getToolbarRef",
    value: function getToolbarRef() {
      var toolbarRef = window.abcdef_editorToolbar;
      return toolbarRef;
    }
  }, {
    key: "getEditorUtils",
    value: function getEditorUtils() {
      if (this.editorUtils) return this.editorUtils;
      if (!this.editor) this.getEditor();
      this.editorUtils = new EditorUtils(this.editor);
      return this.editorUtils;
    }
  }, {
    key: "getTableUtils",
    value: function getTableUtils() {
      if (this.tableUtils) return this.tableUtils;
      if (!this.editor) this.getEditor();
      this.tableUtils = new TableUtils(this.editor);
      return this.tableUtils;
    }
  }]);
  return EditorContext;
}();
export default EditorContext;